module.exports = __webpack_public_path__ + "static/cafe-84b80329a0281d5f714d594261f6b3a3.jpg";